import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../../routing/getFlowKey';
const ACQ177_PRODUCTISED_FLOWS = [Flow.Sales, Flow.Marketing, Flow.Service, Flow.Purchase, Flow.Crm];
export const isACQ177ProductisedFlow = () => ACQ177_PRODUCTISED_FLOWS.includes(getFlowKey());